import { useTranslation } from "react-i18next"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"
import type { LotDetail } from "@/features/lots/api/types"
import { LotCompositionCard } from "@/features/lots/components/lot-composition-card"

interface LotCompositionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  lot: LotDetail
}

// Renders the per-load provenance table inside a dialog. Uses the
// existing card layout so the visual treatment matches anywhere else
// the composition might be embedded.
export function LotCompositionDialog({
  open,
  onOpenChange,
  lot,
}: LotCompositionDialogProps) {
  const { t } = useTranslation("lots")

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("detail.composition.dialogTitle")}</DialogTitle>
          <DialogDescription>
            {t("detail.composition.dialogSubtitle", {
              lot: lot.lotNumber,
            })}
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="-mx-6 min-h-0 flex-1 px-6">
          <LotCompositionCard lot={lot} />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
